import o from"../config.js";import{__spread as n}from"../_virtual/_tslib.js";function t(t,i,r){o.verbose&&"function"==typeof console[i]&&(t&&t.$options&&t.$options.name&&(r=n(["["+t.$options.name+"]"],r)),console[i].apply(console,n(r)))}function i(){for(var o=[],n=0;n<arguments.length;n++)o[n]=arguments[n];t(this,"warn",o)}function r(){for(var o=[],n=0;n<arguments.length;n++)o[n]=arguments[n];t(this,"debug",o)}function e(o){return{warn:i.bind(o),debug:r.bind(o)}}export{e as createLogger,r as debug,i as warn};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/utils/log.js
// module id = null
// module chunks = 